//
// Communication Actions

import { createAction, props } from '@ngrx/store';
import { QueryParams, QueryResult } from 'src/app/modules/core/store/models';
import {
  Template,
  ConfiguredChannel,
  Communication,
  RenderedTemplate,
  CommunicationActivity,
  CommunicationRecipientActivity,
  EverbridgeTemplate
} from 'src/app/modules/management/store/communication-center/communications.model';
import { Document } from 'src/app/modules/core/store/models/document.model';

//
export const getConfiguredChannelsFromApi = createAction(
  '[Sharing/Api] Get Configured Channels from Api',
  props<{ queryParams: QueryParams }>()
);
export const getConfiguredChannelsFromApiComplete = createAction(
  '[Sharing/Api] Get Configured Channels from Api Complete',
  props<{ results: QueryResult<ConfiguredChannel> }>()
);
export const getCommunicationTemplatesFromApi = createAction(
  '[Sharing/Api] Get Communication Templates',
  props<{ queryParams: QueryParams }>()
);
export const getCommunicationTemplatesFromApiComplete = createAction(
  '[Sharing/Api] Get Communication Templates Complete',
  props<{ results: QueryResult<Template> }>()
);
export const showShareDocumentDialog = createAction(
  '[Sharing/Page] Show Share Dialog',
  props<{ selectedChannel: ConfiguredChannel; selectedTemplate: Template }>()
);
export const hideShareDocumentDialog = createAction('[Cop/Sharing] Hide Share Dialog');
export const getCommunicationTemplatePreviewFromApi = createAction(
  '[Sharing/Api] Get CommunicationTemplate Preview From Api',
  props<{ communication: Communication }>()
);
export const getCommunicationTemplatePreviewFromApiComplete = createAction(
  '[Sharing/Api] Get CommunicationTemplate Preview From Api Complete',
  props<{ renderedTemplate: RenderedTemplate }>()
);
export const sendCommunicationWithApi = createAction(
  '[Sharing/Api] Send Communication With Api',
  props<{ communication: Communication }>()
);
export const sendCommunicationWithApiComplete = createAction('[Sharing/Api] Send Communication With Api Complete');

// Communication Activity
export const getCommunicationActivityForDocument = createAction(
  '[Sharing/Communication/API] Get Communication History For Document',
  props<{ documentUId: string }>()
);
export const getCommunicationActivityForDocumentComplete = createAction(
  '[Sharing/Communication/API] Get Communication History For Document Complete',
  props<{ data: QueryResult<CommunicationActivity> }>()
);
export const getHistoricCommunicationFromApi = createAction(
  '[Sharing/Communication/API] Get Historic Communication',
  props<{ communicationUId: string; channelUId: string, channelName: string }>()
);
export const getHistoricCommunicationFromApiComplete = createAction(
  '[Sharing/Communication/API] Get Historic Communication Complete',
  props<{ communication: Communication; channelUId: string, channelName: string }>()
);
export const getCommunicationRecipientActivityFromApi = createAction(
  '[Sharing/Communication/API] Get Communication Recipient Activity',
  props<{ communicationUId: string }>()
);
export const getCommunicationRecipientActivityFromApiComplete = createAction(
  '[Sharing/Communication/API] Get Communication Recipient Activity Complete',
  props<{ results: QueryResult<CommunicationRecipientActivity> }>()
);

export const getEverbridgeTemplatesForConfiguredChannelFromApi = createAction(
  '[Sharing/Channel/API] Get Everbridge Templates For ConfiguredChannel',
  props<{ channel: ConfiguredChannel }>()
);
export const getEverbridgeTemplatesForConfiguredChannelFromApiComplete = createAction(
  '[Sharing/Channel/API] Get Everbridge Templates For ConfiguredChannel Complete',
  props<{ templates: EverbridgeTemplate[] }>()
);

export const replaceEverbridgeTokensFromApi = createAction(
  '[Sharing/Channel/API] Replace Tokens in Everbridge Template from Document',
  props<{ template: EverbridgeTemplate; document: Document }>()
);
export const replaceEverbridgeTokensFromApiComplete = createAction(
  '[Sharing/Channel/API] Replace Tokens in Everbridge Template from Document Complete',
  props<{ template: EverbridgeTemplate }>()
);

export const showShareDocumentEverbridgeDialog = createAction(
  '[Sharing//Page] Show Everbridge Share Dialog',
  props<{ selectedChannel: ConfiguredChannel; selectedEverbridgeTemplate: EverbridgeTemplate }>()
);

export const showCommunicationHistoryDialog = createAction('[Sharing/Communication/API] Show Communication History Dialog');
export const hideCommunicationHistoryDialog = createAction('[Sharing/Communication/API] Hide Communication History Dialog');

export const showMassNotificationHistoryDialog = createAction('[Sharing/Communication/API] Show MassNotification History Dialog');
export const hideMassNotificationHistoryDialog = createAction('[Sharing/Communication/API] Hide MassNotification History Dialog');

export const setError = createAction('[Sharing/Page] Set Error', props<{ err: any }>());
